import type {MerchantInitWDto} from '@cohort/wallet-schemas/merchant';
import {createContext} from 'react';

const MerchantContext = createContext<MerchantInitWDto | null>(null);

export default MerchantContext;
